import { Animation, Color, Sprite } from 'excalibur';
import { subtleTint } from './subtleTint';

export const tintAnimation = (anim: Animation, tint: Color, strength: number = 0.5) => {
    tint = subtleTint(tint, strength);
    const anyAnim = anim as any;
    const sprites: Array<Sprite> = anyAnim.sprites ?? anyAnim.frames?.map((f: any) => f.graphic ?? f.sprite) ?? [];
    for (const s of sprites.filter(s => !!s)) s.tint = tint;
}
